import styles from "./Slide.module.scss"
import Link from "../../Link"
import { Check } from "react-feather"
import WysiwygDialog from "../../WysiwygDialog"

const ProductSliderSlide = ({ data }) => {
  if (!data) return null

  const {
    title,
    product_description: description,
    product_additional_information: information,
    product_additional_information_button_label: buttonLabel,
    product_price: price,
    product_price_from: from,
    product_services: services,
    product_link_label: label,
    product_link_link: link,
    product_link_new_tab: newTab,
    product_link_icon_position: iconPosition,
    product_link_display_type: displayType,
  } = data

  return (
    <div className={styles.PriceSlider__Slide}>
      <div>
        {title && (
          <div
            className={styles.headline}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {description && (
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        {price && (
          <div className={styles.price}>
            <span className="text-body-small font-semibold mr-2">
              {from ? "ab " : ""}€
            </span>
            <span dangerouslySetInnerHTML={{ __html: price }} />
            <span>,-</span>
          </div>
        )}
        {services && (
          <ul className={styles.services}>
            {services.map((service, index) => (
              <li key={index} className={styles.service}>
                <span className={styles.icon}>
                  <Check />
                </span>
                <span>{service}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
      {link && (
        <>
          {information && buttonLabel && (
            <WysiwygDialog
              label={buttonLabel}
              content={information}
              buttonClassName="text-brand-orange mb-8"
            />
          )}

          <Link
            link={{
              link: link,
              label: label,
              new_tab: newTab,
              display_type: { value: displayType?.value },
              icon_position: { value: iconPosition?.value },
            }}
          />
        </>
      )}
    </div>
  )
}

export default ProductSliderSlide
